import { SVGProps } from "react";

const Delete = (props: SVGProps<SVGSVGElement> & { pathColor?: string }) => {
  const { pathColor, ...mainProps } = props;

  return (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...mainProps}
    >
      <path
        d="M17.916 19.7083V30.4583"
        stroke={pathColor || "#FE3939"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.084 19.7083V30.4583"
        stroke={pathColor || "#FE3939"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.16602 12.5417H35.8327"
        stroke={pathColor || "#FE3939"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.75 12.5417H21.5H32.25V34.6251C32.25 36.2819 30.9069 37.6251 29.25 37.6251H13.75C12.0931 37.6251 10.75 36.2819 10.75 34.6251V12.5417Z"
        stroke={pathColor || "#FE3939"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.125 7.375C16.125 6.27043 17.0204 5.375 18.125 5.375H24.875C25.9796 5.375 26.875 6.27043 26.875 7.375V12.5417H16.125V7.375Z"
        stroke={pathColor || "#FE3939"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Delete;
